import { Injectable } from '@angular/core';
import { TuiPortalService } from '@taiga-ui/cdk';

@Injectable({
  providedIn: 'root',
})
export class DrawerPortalService extends TuiPortalService {}
